// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const industrySuggestInNameMax = 120;

export const IndustrySuggestIn = zod.object({
  "name": zod.string().min(1).max(industrySuggestInNameMax)
});

export type IndustrySuggestIn = zod.input<typeof IndustrySuggestIn>;
export type IndustrySuggestInOutput = zod.output<typeof IndustrySuggestIn>;
